import React, { useContext, useEffect, useState } from "react";
import { fetchUsers } from "../api/api";
import { UserContext } from "../context/UserContext";
import { AzureCloudInstance } from "@azure/msal-browser";

export default function HeaderQC() {
  const { user } = useContext(UserContext);
  const [userData, setUserData] = useState([]);

  const fetchRole = async () => {
    if (!user) return;
    const sus = await fetchUsers(user);
    setUserData(sus);
  };

  useEffect(() => {
    fetchRole();
  }, [user]);

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    window.location.href = "/login";
  };

  return (
    <header
      style={{ backgroundColor: "#1DA5B1" }}
      className="text-white py-4 px-1 shadow-sm"
    >
      <div className="row align-items-center gap-2 px-4">
        <div className="col-auto d-flex align-items-center">
          <img
            src="/logo.png"
            alt="Logo"
            className="img-fluid"
            style={{ height: "50px" }}
          />
        </div>
        <div className="col d-flex align-items-center justify-content-between">
          <h2 className="mb-0">QC Panel</h2>
          <div className="d-flex align-items-center gap-2">
            <p className="mb-0 me-2">
              {userData.role} {userData.team_id} | {userData.first_name}{" "}
              {userData.last_name}
            </p>
            <button
              className="btn btn-danger"
              title="Logout"
              onClick={handleLogout}
              style={{ padding: "0.2rem 0.5rem" }} // optional: adjust size
            >
              <i className="bi bi-box-arrow-right fs-5 text-white" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
